module.exports = __webpack_public_path__ + "img/trash.c9dbf62a.svg";